<app-bread-crumb [items]="[{text:  'produtos',link:'/admin/products'},{text:pageTitle}]"
    [sectionTitle]="pageTitle"></app-bread-crumb>


<section class="content">


    <form [formGroup]="objectForm" novalidate (ngSubmit)="submitForm()">

        <ng-box [boxIcon]="'fa fa-briefcase'" [boxTitle]="'Produto'" [showBoxFooter]="true">

            <!-- cabesalho do box -->
            <ng-container class="ng-box-header">

                <ng-button (click)="back()" [button]="{name:'back',faIconClass:'fa fa-arrow-left',color:'secondary'}"></ng-button>

            </ng-container>

            <!-- conteudo -->
            <ng-container class="ng-box-content">

                <div class="row">

                    <div class="col-md-6">

                        <div class="form-group">

                            <app-input label="Clube(*)" errorMessage="Campo obrigatório">

                                <select formControlName="clubs_id" class="form-control">
                                    <option *ngFor="let club of clubs" [value]="club.id">{{ club.name }}</option>
                                </select>

                            </app-input>

                        </div>

                    </div>
                    <div class="col-md-6">

                        <div class="form-group">

                            <app-input label="Categoria(*)" errorMessage="Campo obrigatório">

                                <select formControlName="product_category_id" class="form-control" #iptCategory (change)="setCategory(iptCategory.value)">

                                    <option *ngFor="let category of categories"  [value]="category.id">
                                        {{ category.name }}
                                    </option>

                                </select>

                            </app-input>

                        </div>

                    </div>
                </div>

                <div class="row">

                    <div class="col-md-4">

                        <div class="form-group">

                            <app-input label="Subcategoria(*)" errorMessage="Campo obrigatório">

                                <select formControlName="subcategorias_id" class="form-control">

                                    <option value="">Escolha subcategoria</option>
                                    <option *ngFor="let subcategory of category?.subcategorias"
                                        [value]="subcategory.id">
                                        {{ subcategory.name }}
                                    </option>
                                </select>
                            </app-input>

                        </div>

                    </div>
                    <div class="col-md-4">

                        <div class="form-group">

                            <app-input label="Promoção(*)" errorMessage="Campo obrigatório">

                                <select formControlName="flash" class="form-control">

                                    <option value="">Escolha Promoção</option>
                                    <option value="0">Não Promocionar</option>
                                    <option value="1">Promocionar</option>
               
                                </select>
                            </app-input>

                        </div>

                    </div>
             
                    <div class="col-md-4">

                        <div class="form-group">

                            <app-input label="Designação do Produto(*)" errorMessage="Campo obrigatório">
                                <input type="text" formControlName="title" class="form-control">
                            </app-input>

                        </div>

                    </div>

                </div>

                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">

                            <app-input label="Descrição do Produto" errorMessage="Campo obrigatório">
                                <textarea class="textarea" formControlName="description" class="form-control" cols="30"
                                    rows="6"></textarea>
                            </app-input>

                        </div>
                    </div>
                </div>

            </ng-container>

            <ng-container class="ng-box-footer">
                <div class="row">
                    <div class="col-xs-12">

                        <ng-button *ngIf="isAdmin()" class="pull-right" [button]="{
                            name:'salvar',
                            color:'danger',
                            faIconClass:'fa fa-save',
                            type:'submit',
                            loadingText:'SALVANDO',
                            isLoading:isButtonLoading,
                            isDisabled:isButtonLoading || objectForm.invalid}">
                        </ng-button>

                    </div>
                </div>
            </ng-container>

        </ng-box>

    </form>